<template>
    <div class="w-75 mb-2">
        <select class="form-select" v-model="pendingReason">
            <option selected :value="null">Select Reason</option>
            <option v-for="[key, value] of patientPendingReasons" :value="value.value" :key="key">
                {{ value.name }}
            </option>
        </select>
    </div>
    <div class="form-group">
        <textarea
            :class="`form-control ${classList.textarea}`"
            rows="4"
            :name="inputName"
            :value="result"
            :placeholder="placeholder"
            :disabled="disabled"
            :maxlength="maxLength"
        ></textarea>
    </div>
</template>

<script lang="ts" src="./PendingReason.ts"></script>
